import React from 'react';
import ClassNames from 'classnames';
import DateTime from 'utils/date-time';
import moment from 'moment-timezone';
import EnhancedButton from 'components/buttons/enhanced-button/EnhancedButton';

export default React.createClass({

	propTypes: {
		date: React.PropTypes.object,
		onTouchTap: React.PropTypes.func,
		selected: React.PropTypes.bool
	},

	render: function() {
		let {
			className,
			date,
			onTouchTap,
			selected,
		} = this.props;

		let classes = ClassNames('lui-date-picker-day-button', { 
			'lui-is-current-date': moment(this.props.date).format("MMM DD YYYY") === moment().format("MMM DD YYYY"),
			'lui-is-selected': this.props.selected
		});

		return this.props.date ? (
			<EnhancedButton {...this.props}
				className={classes}
				disableFocusRipple={true}
				disableTouchRipple={true}
				onClick={this._handleTouchTap}>
				<div className="lui-date-picker-day-button-select" />
				<span className="lui-date-picker-day-button-label">{moment(this.props.date).date()}</span>
			</EnhancedButton>
		) : (
			<span className={classes} />
		);
	},

	_handleTouchTap: function(e) {
		if (this.props.onTouchTap) this.props.onTouchTap(e, this.props.date);
	}

});


/** WEBPACK FOOTER **
 ** ./src/components/date-picker/DayButton.js
 **/